"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToTimeValue = exports.timeValueToDate = exports.dateToDateValue = exports.dateValueToDate = void 0;
const dateValueToDate = (value) => new Date(value.year, value.month, value.day);
exports.dateValueToDate = dateValueToDate;
const dateToDateValue = (date) => ({
    type: "Date",
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate(),
});
exports.dateToDateValue = dateToDateValue;
const timeValueToDate = (value) => new Date(0, 1, 1, value.hour, value.minute, value.second);
exports.timeValueToDate = timeValueToDate;
const dateToTimeValue = (date) => ({
    type: "Time",
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
});
exports.dateToTimeValue = dateToTimeValue;
